<template>
  <mt-dialog
      v-model="computedModelValue"
      class="import-dialog"
      size="md"
  >
    <div class="import-dialog__title">
      <app-title>
        <template #title>{{ title_text }}</template>
      </app-title>
    </div>

    <div class="import-dialog__content">
    </div>

    <app-uploader-file
        accept=".txt"
        v-model="file"
        label="Выбрать файл"
        ref="fileInput"
        @change="(newFile) => file = newFile"
    >
      <template #label>
        Выбрать файл (поддерживаемые форматы: .txt)
      </template>
    </app-uploader-file>
    <mt-button
      @click="runImportSessionAction()"
      :loading="requestPending"
      size="large"
      class="import-dialog__btn"
    >
      Импортировать
    </mt-button>
  </mt-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import MtDialog from "@/components/UI/mtDialog/mtDialog.vue";
import AppTitle from "@/components/layouts/AppTitle/AppTitle.vue";
import AppUploaderFile from "@/components/UI/AppUploaderFile/AppUploaderFile.vue";
import AppAlert from "@/components/UI/AppAlert/AppAlert.vue";
import MtButton from "@/components/UI/mtButton/index.vue";
import {mapActions} from "vuex";
import api from "@/network/index.js";
import AdminSessionsApi from "@/api/admin-sessions.api";
import AppChip from "@/components/UI/AppChips/AppChip.vue";
import MtChip from "@/components/UI/mtChip/index.vue";

export default defineComponent({
  name: "ImportSessionDialog",
  components: {MtChip, AppChip, MtButton, AppAlert, AppUploaderFile, AppTitle, MtDialog },
  props: {
    modelValue: Boolean,
    title_text: String
  },
  data () {
    return {
      file: null,
      requestPending: false
    }
  },
  computed: {

    computedModelValue: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  },
  watch: {
    modelValue(isOpen) {
      if (!isOpen) {
        this.$refs.fileInput?.clear();
        this.file = null;
      }
    }
  },
  methods: {

    async runImportSessionAction() {

      if(!this.file) {
        this.$toast.error("Не выбран файл для импорта");
        return;
      }
      this.requestPending = true;
      AdminSessionsApi.import(this.file)
          .then(res => {
            if(res) this.$toast.success('Сеанс успешно импортирован');
            this.$refs.fileInput.clear();
            this.file = null;
            this.$emit('update:modelValue', false);
            this.$emit('success', false);
            this.$emit('close')
          })
          .catch((error) => {
            this.$toast.error('Что-то пошло не так, пожалуйста проверьте валидность файла')
          })
          .finally(() => {
            this.requestPending = false;
          })
    }
  }
})
</script>

<style lang="scss">
.import-dialog {
  &__title {
    text-align: center;
  }
  &__content {
    font-size: 13px;
    line-height: 1.4;
  }
  &__btn {
    width: 100%;
    margin-top: 30px;
  }
}
</style>